import React from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ProblemSection } from "@/components/ProblemSection";
import { ApproachSection } from "@/components/ApproachSection";
import { ChefSection } from "@/components/ChefSection";
import { MenuSection } from "@/components/MenuSection";
import { LocationsSection } from "@/components/LocationsSection";
import { KioskSection } from "@/components/KioskSection";
import { PartnerSection } from "@/components/PartnerSection";
import { MascotSection } from "@/components/MascotSection";
import { Footer } from "@/components/Footer";
import { QRScanner } from "@/components/QRScanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <ProblemSection />
      <ApproachSection />
      <ChefSection />
      <MenuSection />
      <LocationsSection />
      <KioskSection />
      <PartnerSection />
      <MascotSection />
      <Footer />
      <QRScanner />
      <Toaster />
    </div>
  );
}

export default App;

